import type { PaymentLineItemEnum } from "@b2bportal/air-booking-api";
import type { SummaryLineItemBaseEnum } from "@hopper-b2b/types";

export const DISRUPTION_EXERCISE_BASE = "disruption/exercise";
export const DISRUPTION_EXERCISE_PATH = "/trips/" + DISRUPTION_EXERCISE_BASE;
export const FLIGHT_ITINERARY_PAGE_PATH = "/trips/flights";
export const DISRUPTION_EXERCISE_RELATIVE = DISRUPTION_EXERCISE_BASE;
export const DISRUPTION_EXERCISE_RELATIVE_WITH_RESERVATION =
  DISRUPTION_EXERCISE_RELATIVE + "/:reservationId";

export interface ILineItem {
  PaymentLineItem: PaymentLineItemEnum;
  label: string;
  value: number;
  currency: string;
  type?: SummaryLineItemBaseEnum;
}
